var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-jumbotron',{staticClass:"intro rounded-0"},[_c('b-container',{attrs:{"fluid":"lg"}},[_c('span',[_c('h1',[_vm._v("iAdvize Playground")])]),_c('img',{attrs:{"src":"https://developers.iadvize.com/bundles/devplatformapp/images/logos/iadvizeColored.svg"}})])],1),_c('b-container',{attrs:{"fluid":"lg"}},[_c('TheTestBench')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }